import React, { useState } from 'react';
import './ContactForm.css';
// ==== تم استبدال استدعاءات Firebase بـ apiClient ====
import apiClient from '../../api/axiosConfig';


const ContactForm = () => {
  // استخدام كائن واحد لتخزين بيانات النموذج
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: 'رسالة تواصل من الموقع', // قيمة افتراضية للموضوع
    message: '',
  });

  // حالات لإدارة حالة الإرسال والـ Popup
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState('success');
  const [popupMessage, setPopupMessage] = useState('');

  // دالة لتحديث حالة النموذج عند تغيير المدخلات
  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'phone') {
      const normalizeToAsciiDigits = (s) => s
        .replace(/[\u0660-\u0669]/g, (c) => String(c.charCodeAt(0) - 0x0660))
        .replace(/[\u06F0-\u06F9]/g, (c) => String(c.charCodeAt(0) - 0x06F0));
      value = normalizeToAsciiDigits(value).replace(/\D/g, '');
    }
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // ==== تم استبدال دالة Firebase بدالة تستدعي Laravel API ====
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // تفعيل حالة الإرسال (لتعطيل الزر مثلاً)

    try {
      // إرسال طلب POST إلى Laravel API
      const response = await apiClient.post('/contact-submissions', formData);

      // إذا نجح الطلب
      if (response.status === 201) {
        setPopupMessage('تم إرسال رسالتك بنجاح!');
        setPopupType('success');
        // تفريغ النموذج
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: 'رسالة تواصل من الموقع',
          message: '',
        });
      }
    } catch (error) {
      console.error("Error sending contact form:", error);
      setPopupMessage('حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.');
      setPopupType('failure');
    } finally {
      setIsSubmitting(false); // إيقاف حالة الإرسال
      setShowPopup(true); // إظهار الـ Popup
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
      <>
        <div className="contact">
          <div className="content">
            <div className="left-side">
              <div className="address details">
                <i className="fas fa-map-marker-alt"></i>
                <div className="topic">العنوان</div>
                <div className="text-one">الجيزة،العجوزة</div>
                <br />
                <div className="text-two">
                  العنوان 68 شارع ابو المحاسن الشاذلي العجوزه أعلى فرع اتصالات
                </div>
              </div>
              <div className="phone details">
                <i className="fas fa-phone-alt"></i>
                <div className="topic">ارقام الهواتف</div>
                <div className="text-one">+966 50 655 2565</div>
                <div className="text-two">+20 1110563323</div>
                <div className="text-two">+20 101 176 2864</div>
                <div className="text-two">+20 104 011 0958</div>
              </div>
              <div className="email details">
                <i className="fas fa-envelope"></i>
                <div className="topic">البريد الالكترونى</div>
                <div className="text-one">support@alahram128.com</div>
              </div>
            </div>
            <div className="right-side">
              <div className="topic-text">تواصل معنا</div>
              {/* استخدام دالة handleSubmit الجديدة */}
              <form dir="rtl" method="POST" className="contact-form" onSubmit={handleSubmit}>
                <div className="input-box">
                  {/* ربط المدخلات بالحالة الجديدة */}
                  <input type="text" placeholder="اسمك" required
                         name="name" // مطابقة لأسماء الحقول في Laravel
                         value={formData.name}
                         onChange={handleInputChange} />
                </div>
                <div className="input-box">
                  <input type="email" placeholder="بريدك الالكترونى" required
                         name="email"
                         value={formData.email}
                         onChange={handleInputChange} />
                </div>
                <div className="input-box">
                  <input type="tel" placeholder="رقم الهاتف" dir='rtl'
                         name="phone"
                         value={formData.phone}
                         onChange={handleInputChange}
                         inputMode="numeric" pattern="^[0-9]{7,15}$" minLength={7} maxLength={15} title="يرجى إدخال رقم هاتف صحيح (أرقام فقط بين 7 و15 خانة)" required />
                </div>
                <div className="input-box message-box">
                <textarea placeholder="رسالتك" required
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}></textarea>
                </div>
                <div className="button">
                  {/* تعطيل الزر أثناء الإرسال */}
                  <input type="submit" value={isSubmitting ? 'جاري الإرسال...' : 'ارسل'} disabled={isSubmitting} />
                </div>
              </form>
            </div>

            {showPopup && (
                <div className="popup" onClick={handleClosePopup}>
                  <div
                      className={`popup-content ${popupType === 'success' ? 'popup-success' : 'popup-failure'}`}
                      onClick={(e) => e.stopPropagation()}
                  >
                    <span className="close" onClick={handleClosePopup}>&times;</span>
                    <p>{popupMessage}</p>
                  </div>
                </div>
            )}
          </div>
        </div>
        <div className="map-iframe">
          <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.185277667564!2d31.2126677749381!3d30.060223217823804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14584122003ddab9%3A0xfd8fe7af75d98e64!2zNjgg2KPYqNmIINin2YTZhdit2KfYs9mGINin2YTYtNin2LDZhNmK2Iwg2KfZhNit2YjZitiq2YrYqdiMINit2Yog2KfZhNi52KzZiNiy2KnYjCDZhdit2KfZgdi42Kkg2KfZhNis2YrYstipIDM3NTM2MTI!5e0!3m2!1sar!2seg!4v1715807861549!5m2!1sar!2seg"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
          ></iframe>
        </div>
      </>
  );
};

export default ContactForm;